/**
 * 🧩 JSON CONTROLLER
 * Location: src/registered/common/parsers/JsonController.js
 * Uses native JSON.parse for in-memory object discovery.
 */
export const JsonController = {
    execute: async (buffer, onProgress) => {
        onProgress({ stage: 'OPEN_FILE', status: 'IN_PROGRESS', label: 'Validating JSON structure...' });
        
        try {
            const text = new TextDecoder().decode(buffer);
            const data = JSON.parse(text);
            
            onProgress({ stage: 'OPEN_FILE', status: 'SUCCESS', label: 'JSON validation success.' });

            /**
             * DISCOVERY LOGIC:
             * ESG JSON often arrives as an array of objects. We "flatten" this 
             * to a worksheet format for the Tabbed Preview UI.
             */
            const worksheets = [];
            if (Array.isArray(data)) {
                worksheets.push({
                    name: "ROOT_COLLECTION",
                    headers: Object.keys(data[0] || {}),
                    sampleRows: data.slice(0, 10).map(obj => Object.values(obj)),
                    columnCount: Object.keys(data[0] || {}).length
                });
            } else {
                // Handle single object case
                worksheets.push({
                    name: "OBJECT_ROOT",
                    headers: Object.keys(data),
                    sampleRows: [Object.values(data)],
                    columnCount: Object.keys(data).length
                });
            }

            return { format: 'JSON', worksheets };

        } catch (err) {
            onProgress({ stage: 'OPEN_FILE', status: 'FAIL', label: 'Invalid JSON format.' });
            throw new Error("The file is not a valid JSON object.");
        }
    }
};